import axios, { AxiosInstance, AxiosResponse } from 'axios'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'

// Crear instancia de axios con configuración base
const api: AxiosInstance = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor para añadir token de autorización
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para manejo de respuestas y errores
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response
  },
  (error) => {
    const { response } = error

    // Evitar múltiples toasts para el mismo error
    if (error.config && error.config.__isRetryRequest) {
      return Promise.reject(error)
    }

    if (response?.status === 401) {
      // Token expirado o inválido
      Cookies.remove('access_token')
      Cookies.remove('user')
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
        toast.error('Sesión expirada. Por favor, inicia sesión nuevamente.')
      }
    } else if (response?.status === 403) {
      toast.error('No tienes permisos para realizar esta acción')
    } else if (response?.status >= 500) {
      toast.error('Error del servidor. Inténtalo más tarde.')
    } else if (response?.data?.detail) {
      toast.error(response.data.detail)
    } else if (!error.config?.skipErrorToast) {
      toast.error('Ha ocurrido un error inesperado')
    }

    return Promise.reject(error)
  }
)

export default api

// Función para configurar el token de autorización
export const setAuthToken = (token: string) => {
  if (token) {
    Cookies.set('access_token', token, { expires: 1 }) // 1 día
  } else {
    Cookies.remove('access_token')
  }
}

// Función para obtener el token actual
export const getAuthToken = (): string | undefined => {
  return Cookies.get('access_token')
}

// Función para limpiar la autenticación
export const clearAuth = () => {
  Cookies.remove('access_token')
  Cookies.remove('user')
}